<span class="p-float-label">
  <p-dropdown
  [filter]="true"
  [filterFields]="['name', 'code']"
  [options]="listBank"
  [autoDisplayFirst]="false"
  optionLabel="name"
  optionValue="@id"
  inputId="bank"
  appendTo="body"
  [disabled]="disabled"
  [ngModel]="value"
  [class.ng-invalid]="control.invalid && control.touched"
  [class.ng-valid]="control.valid && control.touched"
  [class.ng-dirty]="control.dirty"
  (ngModelChange)="onDropdownChange($event)"
  >
   <ng-template let-bank pTemplate="selectedItem">
      {{ bank ? ("00" + bank?.code).slice(-3) + " - " + bank?.name : "" }}
    </ng-template>
    <ng-template let-bank pTemplate="item">
      {{ bank ? ("00" + bank?.code).slice(-3) + " - " + bank?.name : "" }}
    </ng-template>
  </p-dropdown>
  <ng-content select="label"></ng-content>
</span>